import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2f1d59b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "date_infobox",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "daterange",
    size: "30",
    value: ""
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "datepicker_container",
  class: "datepicker_container"
}, null, -1))
const _hoisted_3 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_aba_button_right = _resolveComponent("aba-button-right")!
  const _component_modal_fullscreen = _resolveComponent("modal-fullscreen")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_modal_fullscreen, {
      class: "modal-datapicker",
      visible: _ctx.visible,
      onClose: _ctx.close,
      hideFooter: true
    }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("SelectPeriod")), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_aba_button_right, { onClick: _ctx.ChangeDate }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Show")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"])
  ]))
}